/** W73c (D-289 r): zweite Zeile einer Fristenzeile. Steht kein Absender am Brief (etwa wenn der Gaist ihn verworfen hat),
 *  steht dort der Betreff, ohne Betreff „Brief vom …“; nie eine leere Zeile und nie nur die Art („Zahlung“). Wie in
 *  den Apps (iOS W73-I, Android Rueckstand). */
import type { Dokument } from "../api/typen";
import { datumGesprochen } from "../format";

/** Text unter der Art: Absender, sonst Betreff, sonst das Datum des Briefs; ohne Brief nichts. */
export function fristWoher(brief: Pick<Dokument, "betreff" | "datum" | "erstellt"> | undefined, absender: string | null | undefined): string | undefined {
  if (!brief) return undefined;
  return absender?.trim() || brief.betreff?.trim() || datumGesprochen(brief);
}

/** W80 (W5, D-352 F1): Fristen ohne Brief. Mit Akte steht unter der Art „Akte: <Name>“; eine eigene Frist mit Titel zeigt
 *  den Titel als erste Zeile, darunter Art und Herkunft. Mit Brief bleibt alles wie oben. */
export function fristAkteZeile(f: { dokument_id: string | null; akte_id: string | null }, akteName: string | null | undefined): string | undefined {
  if (f.dokument_id || !f.akte_id || !akteName?.trim()) return undefined;
  return `Akte: ${akteName.trim()}`;
}

export function fristTitel(f: { titel?: string | null }): string | undefined {
  return f.titel?.trim() || undefined;
}
